const NavLink = {
    menu: [
        {
            id: 'item1',
            name: 'صفحه اصلی',
            link: '/',
            icon: 'fa fa-home'

        },
        {
            id: 'item2',
            name: 'کی خوبه ؟',
            link: '/who',
            icon: 'fa fa-id-card'
        },
        {
            id: 'item3',
            name: 'کجا خوبه ؟',
            link: '/where',
            icon: 'fa fa-map-marker'
        },
        {
            id: 'item4',
            name: 'فروشگاه',
            link: '/shop',
            icon: 'fa fa-shopping-basket'
        },
        {
            id: 'item5',
            name: 'درباره ما',
            link: '/about',
            icon: 'fa fa-users '

        }
    ]
}

const getNavLinks = () => {
    return {...NavLink}
}

export default getNavLinks;